import { render } from "./BoxUploadComponent.vue?vue&type=template&id=10a8744f&scoped=true"
import script from "./BoxUploadComponent.vue?vue&type=script&lang=js"
export * from "./BoxUploadComponent.vue?vue&type=script&lang=js"

import "./BoxUploadComponent.vue?vue&type=style&index=0&id=10a8744f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a8744f"]])

export default __exports__